<template>
  <div>
    <div class="table_card">
      <div class="table_card__head">
        <p class="table_card__head--title">
          Búsqueda de reservas activas de usuario
        </p>
      </div>
      <div class="table_card__body">
        <v-layout row wrap>
          <v-flex xs12 row>
            <v-form onSubmit="return false;" ref="form" v-model="valid" lazy-validation>
              <v-layout row wrap style="background-color: #fff; padding: 0px;">
                <v-flex xs6>
                  <input
                    v-model="searching_rut"
                    placeholder="Ingrese el documento del usuario"
                    required
                    class="input_solid"
                    style="width: 98% !important"
                  >
                  <img
                    src="@/assets/img/icons/search-icon.svg"
                    class="button_search"
                    style="margin-left: -55px"
                  >
                </v-flex>
                <v-flex xs6 class="pl-2">
                  <button
                    type="button"
                    class="faccess_button px-5"
                    @click="getUserData()"
                    :disabled="!valid || searching_rut == '' || searching_rut.length > 10"
                  >
                    Consultar
                  </button>
                </v-flex>
              </v-layout>
            </v-form>
          </v-flex>
        </v-layout>
      </div>
    </div>



    <div v-if="bookings_found !== '' && bookings_found">
      <v-layout row>
        <p class="accessIndex__text--title">Reservas de Usuario</p>
      </v-layout>
      <br />
      <div class="time_select">
        <div
          v-for="(booking, index) in bookings"
          :key="index"
          class="time_select__item"
        >
          <div class="time_select__item--begin">
            <p>Hora Ingreso</p>
            <div>
              <img
                src="@/assets/img/sportlife/flecha-entrada-verde.svg"
                alt=""
              />
              <span>{{ setTimeFilter(booking.attributes.start_time) }}</span>
            </div>
          </div>
          <div class="time_select__item--end">
            <p>Hora Salida</p>
            <div>
              <img src="@/assets/img/sportlife/flecha-salida-roja.svg" alt="" />
              <span>{{ setTimeFilter(booking.attributes.end_time) }}</span>
            </div>
          </div>
          <div class="time_select__item--begin">
            <div>
              <span style="font-weight: bold; font-size: 18px;">{{
                booking.attributes.location
              }}</span>
            </div>
          </div>
          <div class="time_select__item--end" style="padding: 15px">
            <div>
              <span>{{ booking.attributes.sublocation }}</span>
            </div>
          </div>
          <button
            @click="cancelBooking(booking.id)"
            style="background-color: red"
            class="time_select__item--button"
          >
            Cancelar Reserva
          </button>
        </div>
      </div>
    </div>
    <div v-else-if="bookings_found !== '' && !bookings_found">
      <v-layout row>
        <p class="accessIndex__text" style="margin-top: 20px;">
          El usuario no cuenta con reservas activas actualmente
        </p>
      </v-layout>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searching_rut: '',
      user_rut: '',
      bookings: [],
      rules: {
        required: value => !!value || "Required."
      },
      bookings_found: '',
      valid: false
    };
  },
  methods: {
    getUserData() {
      try {
        this.$http
          .get("app/bookings/user_active_bookings", {
            headers: {
              "X-Device-ID": this.getDeviceId(),
              Authorization: "Bearer " + this.getUserToken()
            },
            params: {
              rut: this.searching_rut
            }
          })
          .then(
            function(response) {
              if (response.body != null) {
                var data = response.body.data;
                if(data.length > 0){
                    this.bookings = data;
                    this.user_rut = this.searching_rut;
                    this.bookings_found = true;
                }else{
                    this.bookings_found = false;
                }
              } else {
                this.bookings_found = false;
                this.updateAlertMessage(
                  "No se ha encontrado el usuario con el rut ingresado"
                );
                this.updateIsInAlert(true);
              }
            },
            function(response) {
              // this.updateAlertMessage("No te hemos encontrado en los registros de sportlife", "Lo sentimos")

              this.user_finded = false;
              this.updateAlertMessage(
                "No se ha encontrado el usuario con el rut ingresado"
              );
              this.updateIsInAlert(true);
            }
          );
      } catch (e) {
        this.updateAlertMessage(e.message);
        this.updateIsInAlert(true);
      }
    },
    cancelBooking(id) {
      var vm = this;
      try {
        vm.$http
          .put(
            `app/bookings/${id}/change_to_cancelled`,
            {},
            {
              headers: {
                "X-Device-ID": this.getDeviceId(),
                Authorization: "Bearer " + this.getUserToken()
              },
              params: { rut: this.user_rut }
            }
          )
          .then(function(response) {
            this.updateAlertMessage("Se ha cancelado exitosamente la reserva");
            this.updateIsInAlert(true);
            this.searching_rut = "";
            this.user_rut = "";
            this.bookings_found = "";
          })
          .catch(function(response) {
            this.updateAlertMessage(
              "Ha ocurrido un error cancelando la reserva"
            );
            this.updateIsInAlert(true);
            console.log(response);
          });
      } catch (e) {
        console.log("error", e);
      }
    },
    convertHourToStyleFormat(hour) {
      var arr = hour.split(":");
      var amOrPm = "am";
      if (arr[0] >= 12) {
        amOrPm = "pm";
        if (arr[0] > 12) {
          arr[0] = Number(arr[0]) % 12;
        }
      } else if (arr[0] == 0) {
        arr[0] = 12;
      }
      if (Number(arr[0]) < 10) {
        arr[0] = "0" + Number(arr[0]).toString();
      }
      return arr[0] + ":" + arr[1] + " " + amOrPm;
    },
    setTimeFilter(value) {
      let received_date = new Date(value);
      let clientOffset = new Date().getTimezoneOffset();
      let startDate = received_date.toLocaleString("en-GB", {
        timeZone: value.time_zone
      });
      let hour = startDate.split(",")[1];
      let realHour = hour.split(":");
      let time = this.convertHourToStyleFormat(realHour[0] + ":" + realHour[1]);
      return time;
    }
  } /* closed methods */
};
</script>



// WEBPACK FOOTER //
// src/components/views/bookings/CancelBooking.vue